import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './Auth';
import './tempo.css';

if (import.meta.env.PROD && 'serviceWorker' in navigator) window.addEventListener('load', () => {
  void navigator.serviceWorker.register('/sw.js').catch(error => console.warn('Offline shell belum tersedia:',error));
});
createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
